import { CommonModule } from "@angular/common";
import { Component, inject } from "@angular/core";
import { BehaviorSubject, combineLatest, switchMap } from "rxjs";
import { getParams } from "../../../../../utils/utils";
import { EventsManagementService } from "../../../../services/events-management.service";
import {
  BatchSalesReportTableComponent,
  SellerSalesPageChange,
} from "./batch-sales-report-table/batch-sales-report-table.component";
import { SkeletonModule } from "primeng/skeleton";
import { GroupGuestsPipe } from "./pipes/group-guests.pipe";

@Component({
    selector: "app-sales-resume-section",
    imports: [
        CommonModule,
        BatchSalesReportTableComponent,
        SkeletonModule,
        GroupGuestsPipe,
    ],
    templateUrl: "./sales-resume-section.component.html",
    styleUrl: "./sales-resume-section.component.scss"
})
export class SalesResumeSectionComponent {
  private readonly _eventsService = inject(EventsManagementService);
  private readonly sellerPageState$ = new BehaviorSubject<SellerSalesPageChange>(
    {
      page: 0,
      perPage: 5,
    },
  );

  ticketsByCategory$ = getParams("id").pipe(
    switchMap((idSociedade) =>
      this._eventsService.getTicketsByCategorySummary(idSociedade),
    ),
  );

  sellersSummary$ = combineLatest([getParams("id"), this.sellerPageState$]).pipe(
    switchMap(([eventId, pageState]) =>
      this._eventsService.getSellerSalesSummary(
        eventId,
        pageState.page,
        pageState.perPage,
      ),
    ),
  );

  handleSellerPageChange(pageState: SellerSalesPageChange): void {
    this.sellerPageState$.next(pageState);
  }
}
